import TagManager from 'react-gtm-module';
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || '',
};

export const initGTM = () => {
  TagManager.initialize(tagManagerArgs);
};

export function setDataLayer(obj: any) {
  const _window = window as any;
  let _dataLayer = _window.dataLayer as any;
  if (!_dataLayer) {
    _dataLayer = [];
  }
  _dataLayer.push(obj);
}
